<template>
  <div id="home">
    <b-navbar toggleable="sm" type="light" class="w-100 pl-5 pr-5">
      <b-navbar-toggle
        target="nav-text-collapse"
        @click.prevent="mobileNavbar()"
      ></b-navbar-toggle>
      <b-collapse id="nav-text-collapse" class="homeNavbar" is-nav>
        <b-navbar-nav>
          <img
            class="ml-5 cp"
            @click.prevent="selectNavbarFunc(1)"
            :src="require(`@/assets/images/home/vadaroom-logo-white.png`)"
          />
          <!-- <b-nav-item
            class="ml-4"
            :class="[isShow == 1 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(1)"
            >خانه</b-nav-item
          > -->
          <b-nav-item
            class="ml-4"
            :class="[isShow == 2 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(2)"
            >تماس با ما</b-nav-item
          >
          <b-nav-item
            class="ml-4"
            :class="[isShow == 3 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(3)"
            >راهنما</b-nav-item
          >
          <b-nav-item
            :class="[isShow == 4 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(4)"
            >پشتیبانی</b-nav-item
          >
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <div v-if="isShow == 1" id="animationSvg" class="context f-c-s f-d-c">
      <div class="wrapper">
        <svg
        :class="{ active: animateStroke, 'fill-active': animateFill }"
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="311.23 613.26 1297.59 693.51"
        width="1297.5899658203125"
        height="693.510009765625"
        style="width: 20rem; height: 11rem"
      >
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1606.78,620.71c-.48,29.17-.91,58.29-1.34,87.46-.09,5.19-10.73,8.01-14.28,8.44-4.2.52-10.86.26-10.78-5.19.39-26.79.78-53.57,1.21-80.36,2.68-.48,5.32-.95,8.01-1.43.95-.17,1.95-.35,2.9-.52-3.59-1.73-7.18-3.46-10.78-5.19-.04,2.38-.09,4.76-.13,7.14-27.78,5.02-55.61,10.04-83.39,15.06-5.58,1-11.17,1.99-16.75,2.99-4.15.78-8.31,1.51-12.42,2.25-3.12.56-7.18,1.64-9.69,2.6-24.58,9.61-40.9,34.79-42.8,61.45-1.04,14.06-.56,28.35-.78,42.45-.26,14.71-.69,29.43-.69,44.14,0,25.84,13.33,51.24,35.62,64.74,11.08,6.71,23.5,10.56,36.48,10.47,4.93-.04,10.47-1.13,15.75-2.08,29.77-5.32,59.55-10.69,89.32-16.05,4.15-.74,10.86-.09,10.78,5.24-.52,34.84-17.14,68.25-43.62,90.79-19.91,16.96-43.84,26.74-69.41,31.33-14.97,2.68-29.95,5.41-44.88,8.09-32.2,5.8-64.39,11.6-96.59,17.4-.69.13-1.64.22-2.68.22h-.56c-.26,0-.52-.04-.78-.04h-.09c-.39-.04-.82-.09-1.25-.17-.61-.04-1.17-.22-1.73-.39-.65-.22-1.3-.48-1.9-.82-4.11-2.08-6.84-6.4-6.75-11.29.09-6.92,5.8-12.42,12.72-12.33,6.06.09,11.04,4.46,12.12,10.21,10.69-1.9,21.38-3.85,32.07-5.8,34.71-6.23,69.41-12.51,104.12-18.74,6.36-1.17,12.9-2.94,18.78-5.32,12.33-4.98,23.93-12.85,33.71-22.68,18.52-18.56,29.3-44.01,31.29-70.02,2.64-.48,5.24-.95,7.88-1.43,1.13-.22,2.21-.39,3.29-.61-3.59-1.73-7.18-3.46-10.78-5.19-.04,2.42-.13,4.85-.39,7.23-27.83,5.06-55.7,10.21-83.56,15.02-29.34,5.02-60.5-3.46-81.31-25.27-16.62-17.44-22.98-39.42-22.63-63.01.3-18.48.56-37,.87-55.52.26-17.61-.56-35.18,6.36-51.84,12.59-30.42,40.85-49.94,72.66-55.91,11.51-2.16,23.07-4.15,34.58-6.23,30.51-5.5,60.97-10.99,91.48-16.49,4.11-.74,10.86-.09,10.78,5.24Z"
          class="svg-elem-1"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1577.96,867.51c3.59,1.73,7.18,3.46,10.78,5.19-1.08.22-2.16.39-3.29.61-2.64.48-5.24.95-7.88,1.43.26-2.38.35-4.8.39-7.23Z"
          class="svg-elem-2"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1592.5,629.11c-.95.17-1.95.35-2.9.52-2.68.48-5.32.95-8.01,1.43.04-2.38.09-4.76.13-7.14,3.59,1.73,7.18,3.46,10.78,5.19Z"
          class="svg-elem-3"
        ></path>
        <circle
          fill="transparent"
          cx="1592.89"
          cy="712.65"
          r="12.53"
          class="svg-elem-4"
        ></circle>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1345.27,1012.14h-.17c-.22,0-.43,0-.61-.04.26,0,.52.04.78.04Z"
          class="svg-elem-5"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1335.51,662.54c-.48,30.91-.95,61.83-1.43,92.74-.75,49.05-1.51,98.1-2.26,147.15-.17,11.28-.35,22.56-.52,33.84-.06,4.06,24.97.66,25.08-6.72.48-30.91.95-61.83,1.43-92.74.75-49.05,1.51-98.1,2.26-147.15.17-11.28.35-22.56.52-33.84.06-4.06-24.97-.66-25.08,6.72h0Z"
          class="svg-elem-6"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1301.77,780.44c0,.74-.04,1.43-.04,2.12-.35,32.98-1,65.91-1.51,98.88-.17,12.38-.35,24.71-.56,37.09-.39,23.41-7.36,46.35-20.34,65.86-16.57,24.97-41.5,42.76-69.76,52.23-13.89,4.67-28.86,6.58-43.28,9.17-26.1,4.72-52.19,9.39-78.28,14.11-29.38,5.28-58.81,10.56-88.19,15.84-.39.09-.87.13-1.34.13-.48.04-.95.04-1.43.04-.43,0-.87-.04-1.26-.09-.43-.04-.87-.13-1.25-.22-1.56-.3-2.99-.95-4.24-1.77-3.42-2.29-5.63-6.23-5.58-10.65.13-6.92,5.8-12.42,12.72-12.33,5.67.09,10.39,3.89,11.86,9.09,28.99-5.19,57.99-10.43,86.98-15.62,27-4.89,54.01-9.74,81.01-14.63,15.36-2.77,26.87-4.59,40.51-11.6,21.59-11.12,39.94-32.02,48.94-55.35,5.97-15.49,7.66-31.46,7.88-47.91.26-15.62.48-31.24.74-46.87.39-25.53.78-51.15,1.17-76.73-9.26,1.69-18.52,3.33-27.83,5.02-22.5,4.02-45.01,8.09-67.55,12.12-22.98,4.15-45.91,8.31-68.89,12.42-.3,21.55-.65,45.79-.95,66.99v.17c0,.82-.04,1.64-.04,2.47v.17c-.09.48-.17.95-.3,1.43-1.34,5.58-6.4,9.74-12.42,9.61-6.97-.09-12.55-5.84-12.46-12.81,0-.3.04-.61.04-.91,0-.13.04-.26.04-.35.3-23.37.69-46.74,1.04-70.11.09-5.58,10.26-8.09,14.19-8.78,12.98-2.38,25.97-4.72,38.95-7.05,22.5-4.02,45.01-8.09,67.55-12.16,27.65-4.98,55.31-9.91,82.96-14.89,4.46-.82,11.04.39,10.95,5.84Z"
          class="svg-elem-7"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m990.28,1073.85c1.25.82,2.68,1.47,4.24,1.77-1.6-.26-3.16-.87-4.24-1.77Z"
          class="svg-elem-8"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1111.32,889.24c0,.43-.04.82-.09,1.21,0-.82.04-1.64.04-2.47.04.39.04.82.04,1.25Z"
          class="svg-elem-9"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m1024.37,721.25c-.48,30.91-.95,61.83-1.43,92.74-.75,49.05-1.51,98.1-2.26,147.15-.17,11.28-.35,22.56-.52,33.84-.06,4.06,24.97.66,25.08-6.72.48-30.91.95-61.83,1.43-92.74.75-49.05,1.51-98.1,2.26-147.15.17-11.28.35-22.56.52-33.84.06-4.06-24.97-.66-25.08,6.72h0Z"
          class="svg-elem-10"
        ></path>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m982.75,810.35c-.22,14.11-.43,28.22-.65,42.32-.61,39.77-1.26,79.54-1.86,119.31-.39,26.05-7.36,50.59-22.55,72.01-20.69,29.12-53.36,47.43-88.15,53.7-.87.17-2.25.3-3.76.26-.3,0-.61,0-.91-.04-.22,0-.43-.04-.65-.04-.39,0-.82-.09-1.21-.17-.3-.04-.56-.13-.82-.22-.13-.04-.26-.04-.35-.09-.26-.09-.52-.17-.74-.26-.13-.04-.22-.09-.35-.17-4.02-1.6-7.05-5.32-7.62-9.95-.87-6.84,3.98-13.11,10.86-13.98,6.84-.91,13.11,3.98,13.98,10.82.04.17.04.39.04.56,5.41-1.34,10.95-3.29,16.66-5.97,6.62-3.12,14.15-7.96,20.3-13.03,13.11-10.78,23.67-24.84,30.47-40.38,7.57-17.31,9.56-35.23,9.82-53.79.3-18.61.61-37.22.87-55.83.52-32.8,1.04-65.56,1.51-98.36.13-8.91,25.19-13.07,25.1-6.71Z"
          class="svg-elem-11"
        ></path>
        <g>
          <path
            :class="{ '!fill-white': animateFill }"
            fill="transparent"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m872.79,757.46v87.5c0,7.57-25.1,11.29-25.1,6.71v-84c2.47-.43,4.98-.91,7.44-1.34.95-.17,1.9-.35,2.86-.52-3.42-.56-6.84-1.08-10.3-1.64v3.51c-27.83,5.02-55.61,10-83.43,15.02-4.76.87-9.48,1.73-14.19,2.55-7.05,1.25-15.67,2.47-21.38,4.07-9.65,2.77-20.95,10.91-28.65,19.99-8.78,10.34-14.5,23.33-16.75,36.65-2.47,14.67-1.26,30.55-1.47,45.4-.22,14.45-1.17,29.08-.56,43.53,1.17,27.22,16.53,52.02,40.42,65.13,10.99,6.02,23.93,9.35,36.52,8.53,4.15-.26,8.44-1.17,12.77-1.95,29.3-5.28,58.59-10.52,87.89-15.8,1.17-.22,10.39-1.47,10.3,1.6-.52,34.45-16.01,67.51-42.24,89.84-20.3,17.27-44.88,27.48-70.97,32.2-15.06,2.68-30.16,5.41-45.22,8.14-30.77,5.54-61.54,11.08-92.31,16.62-1.43.26-2.81.52-4.24.78-1.43.26-6.23.95-8.74-.17-5.19-1.6-8.91-6.45-8.83-12.16.13-6.92,5.8-12.46,12.72-12.33,6.92.09,12.46,5.8,12.33,12.72,0,.52-.04,1-.13,1.47.78-.13,1.51-.26,2.25-.39,10.69-1.95,21.38-3.89,32.02-5.8,34.79-6.27,69.54-12.55,104.29-18.78,6.75-1.21,11.34-2.34,17.7-4.85,12.03-4.67,23.8-12.85,33.24-22.33,19.73-19.73,31.63-46.87,32.93-74.69-28.04,5.06-56.08,10.26-84.17,15.1-27.39,4.72-56.17-.95-77.07-19.99-17.96-16.36-26.92-39.08-26.57-63.14.3-17.7.56-35.36.82-53.06.3-18.82.3-37.09,9.17-54.35,14.15-27.44,41.89-43.36,71.45-48.9,11.42-2.12,22.89-4.11,34.32-6.14,30.21-5.45,60.37-10.91,90.57-16.31,1.17-.22,10.3-1.51,10.3,1.6Z"
            class="svg-elem-12"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            fill="transparent"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m857.99,765.81c-.95.17-1.9.35-2.86.52-2.47.43-4.98.91-7.44,1.34v-3.51c3.46.56,6.88,1.08,10.3,1.64Z"
            class="svg-elem-13"
          ></path>
        </g>
        <path
          :class="{ '!fill-white': animateFill }"
          fill="transparent"
          stroke="#ffffff"
          stroke-width="5"
          stroke-linecap="round"
          d="m628.2,967.43c-11.12,49.25-56.86,88.54-106.11,96.07-1.64.26-10.99,2.03-10-2.16,1.04-4.07,11.38-6.14,14.76-6.66,4.89-.78,7.57-1.47,11.94-3.29,5.37-2.16,10.39-5.06,15.19-8.22,10.78-7.14,20.34-16.44,28.13-26.7,14.11-18.48,23.63-40.98,23.41-64.48-.17-24.71-.69-49.42-1.04-74.13-.22-13.42-1.34-26.61-8.53-38.39-9.69-15.97-28.43-24.45-46.82-22.2-18.18,2.21-37.13,5.67-55.52,8.53-18.44,2.81-36.83,5.67-55.22,8.48-.04,2.34-.09,4.67-.13,7.01-.13,6.23-.22,12.42-.3,18.65-.35,22.59-.69,45.22-1.04,67.86-.35,21.12-.65,42.24-1,63.35-.39,27.48-.82,54.96-1.25,82.44,0,.17,0,.39-.04.56.09.52.13,1.04.13,1.64-.43,29.12-11.99,57.34-31.03,79.24-20.43,23.46-48.77,38.08-79.15,43.53-4.37.78-12.12-1.38-11.29-7.18.82-5.93,8.05-8.35,13.2-9.39-.13.04-.26.04-.39.04,1.08-.26,3.29-.69,3.76-.82,1.47-.35,2.94-.69,4.41-1.08,2.47-.69,6.36-1.95,7.44-2.38,5.45-2.03,11.47-4.85,15.8-7.49,10.47-6.32,19.6-14.19,27.44-23.63,15.84-19.13,24.15-43.75,24.54-68.5,0-.39.04-.74.13-1.08v-.04c.17-8.87.3-17.74.43-26.61.61-38.73,1.21-77.46,1.82-116.15.09-4.2.13-8.35.22-12.51.43-28.43.87-56.82,1.3-85.21.13-2.47,2.29-4.54,5.28-6.1.35-.17.69-.35,1.08-.48.43-.17.82-.3,1.25-.48.35-.13.74-.26,1.13-.35.09-.04.22-.09.3-.09.52-.17,1.04-.3,1.56-.43.09-.04.17-.04.26-.09.13,0,.22-.04.35-.09,1.56-.35,2.9-.61,3.72-.74.95-.13,1.95-.3,2.9-.43,26.92-4.15,53.79-8.27,80.71-12.42,7.7-1.17,15.36-2.38,23.07-3.55,17.18-2.64,34.88-6.62,52.23-2.55,20.08,4.72,35.31,19.65,40.25,39.73,2.81,11.25,2.08,23.41,2.25,34.97.22,15.67.48,31.37.69,47.04.17,12.46.56,24.67-2.21,36.96Z"
          class="svg-elem-14"
        ></path>

        <g>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m332.62,1245.62l1.99-.35,18.87,56.22,23.47-63.71,1.99-.35-24.73,67.05-1.66.29-19.93-59.15Z"
            class="svg-elem-15"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m535.01,1255.22l-28.83,5.1-6.74,18.46-1.91.34,23.89-65.03,1.66-.29,19.27,57.39-1.91.34-5.43-16.31Zm-12.89-38.4l-15.31,41.79,27.66-4.89-12.36-36.89Z"
            class="svg-elem-16"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m715.14,1209.29c-.71,19.88-11.66,33.39-31.95,36.99l-15.32,2.71,2.36-63.1,15.32-2.71c20.3-3.59,30.39,6.2,29.6,26.1Zm-31.83,35.36c19.55-3.46,29.53-16.62,30.17-35.07.73-18.47-8.52-28.23-28.06-24.77l-13.67,2.42-2.1,59.84,13.67-2.42Z"
            class="svg-elem-17"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m874.93,1195.08l-28.83,5.1-6.74,18.47-1.91.33,23.89-65.03,1.66-.3,19.27,57.39-1.91.34-5.43-16.31Zm-12.89-38.4l-15.31,41.79,27.67-4.89-12.36-36.89Z"
            class="svg-elem-18"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m1024.72,1123.18c13.25-2.35,18.64,3.91,18.32,14.39-.45,10.23-6.03,17.44-15.99,20.36l14.69,24.91-2.07.37-14.59-24.75c-.49.09-.99.18-1.49.27l-13.09,2.32-1.07,27.52-1.66.29,2.36-63.1,14.58-2.58Zm-.11,1.8l-12.92,2.29-1.15,32.07,13.09-2.32c11.93-2.11,17.27-9.91,17.67-19.14.34-9.77-4.18-15.11-16.68-12.9Z"
            class="svg-elem-19"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m1193.86,1156.65c-14.17,2.51-24.48-5.73-26.4-20.44-2.63-20.18,9.63-40.52,28.77-43.9,14.17-2.51,24.39,5.74,26.32,20.45,2.65,20.28-9.63,40.52-28.68,43.89Zm.04-1.61c18.14-3.21,29.44-22.48,26.9-41.97-1.88-14.44-12.03-21.38-24.7-19.14-18.39,3.25-29.4,22.83-26.91,41.88,1.88,14.45,12.04,21.46,24.71,19.22Z"
            class="svg-elem-20"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m1375.45,1124.52c-14.17,2.51-24.48-5.73-26.4-20.44-2.63-20.18,9.63-40.52,28.77-43.9,14.17-2.51,24.39,5.74,26.32,20.45,2.65,20.28-9.63,40.52-28.68,43.89Zm.04-1.61c18.14-3.21,29.44-22.48,26.9-41.97-1.88-14.44-12.03-21.38-24.7-19.14-18.39,3.25-29.4,22.83-26.91,41.88,1.88,14.45,12.04,21.46,24.71,19.22Z"
            class="svg-elem-21"
          ></path>
          <path
            :class="{ '!fill-white': animateFill }"
            stroke="#ffffff"
            stroke-width="5"
            stroke-linecap="round"
            d="m1533.53,1034.95l1.66-.29,22.29,54.55,26.34-63.15,1.66-.29-2.26,61.29-1.66.3,2.07-56.9-25.51,61.05-1.65.3-21.44-52.56-2.09,56.73-1.66.29,2.25-61.3Z"
            class="svg-elem-22"
          ></path>
        </g>
      </svg>
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 704.2 210.036"
          class="mb-4"
        >
          <g
            id="Group_1"
            data-name="Group 1"
            transform="translate(-51.8 -65.2)"
          >
            <path
              id="Path_2"
              data-name="Path 2"
              d="M409.5,71.7a4.483,4.483,0,0,1,.9,1.9,6.458,6.458,0,0,0,.2.9V254.2a17.639,17.639,0,0,1-4.8,10.1,17.143,17.143,0,0,1-10.4,5.1H354v-29c9.3-.1,18.7-.1,28-.2V74.3c0-.2.1-.5.1-.8a3.33,3.33,0,0,1,.9-1.9,4.4,4.4,0,0,1,1.9-1,5.2,5.2,0,0,1,1.1-.2h20.4a7.386,7.386,0,0,1,1.2.2A2.932,2.932,0,0,1,409.5,71.7Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-1"
            ></path>
            <path
              id="Path_3"
              data-name="Path 3"
              d="M623.1,70.8c.8,1.2.8,4.7.8,4.7q0,96.9-.1,193.8H595.2V93.7a5.539,5.539,0,0,1,0-1.3,5.043,5.043,0,0,1,.3-1.4,3.351,3.351,0,0,1,1.4-1.8l2.7-2.1,19.6-15,1.7-1.3C620.8,70.8,622.3,69.7,623.1,70.8Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-2"
            ></path>
            <path
              id="Path_4"
              data-name="Path 4"
              d="M466.1,71.2c.8,1.2.8,4.7.8,4.7q0,96.9-.1,193.8H438.2V94.1a5.539,5.539,0,0,1,0-1.3,5.046,5.046,0,0,1,.3-1.4,3.352,3.352,0,0,1,1.4-1.8l2.7-2.1,19.6-15,1.7-1.3S465.3,70.1,466.1,71.2Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-3"
            ></path>
            <path
              id="Path_5"
              data-name="Path 5"
              d="M495.7,240.3v29a86.742,86.742,0,0,0,51.1-29c19-22.5,20.2-47.5,20.2-56,0-7.3-1-33.8-21.4-57-18.9-21.6-42.7-26.7-49.8-28v28A79.818,79.818,0,0,1,524,150.1c5.9,7.5,14.3,18.4,14.8,34.2.6,19.1-10.9,32.5-14.8,37.1A65.145,65.145,0,0,1,495.7,240.3Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-4"
            ></path>
            <path
              id="Path_6"
              data-name="Path 6"
              d="M749.1,71.7a4.33,4.33,0,0,1,.7.7,10.044,10.044,0,0,1,1.2,2.1V254a16.23,16.23,0,0,1-4.7,10.9,15.168,15.168,0,0,1-10.3,4.4H669.2a3.358,3.358,0,0,1-1.9-.9,2.949,2.949,0,0,1-.9-2c-.3-12.2-.3-21.2,0-23.3a3.561,3.561,0,0,1,1-2.1,3.356,3.356,0,0,1,2.2-.8h53.3v-28a106.6,106.6,0,0,1-27.3-8.1c-9.2-4.1-20.1-9-29.2-19.9-14-16.8-14.3-36.7-14.3-42.5,0-7.2,1.1-25.7,14.3-42.5,10-12.7,22.2-18.3,29.2-21.5a89.1,89.1,0,0,1,27.3-7.5h23.4A11.161,11.161,0,0,1,749.1,71.7Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-5"
            ></path>
            <path
              id="Path_7"
              data-name="Path 7"
              d="M722.8,184.3c0-14.3.1-28.7.1-43,0-14,0-28-.1-42a42.5,42.5,0,0,0,0,85Z"
              fill="#fff"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-6"
            ></path>
            <path
              id="Path_8"
              data-name="Path 8"
              d="M323.9,72.1a4.291,4.291,0,0,1,.7.7,10.043,10.043,0,0,1,1.2,2.1V254.4a16.23,16.23,0,0,1-4.7,10.9,15.168,15.168,0,0,1-10.3,4.4H244a3.358,3.358,0,0,1-1.9-.9,2.949,2.949,0,0,1-.9-2c-.3-12.2-.3-21.2,0-23.3a3.561,3.561,0,0,1,1-2.1,3.357,3.357,0,0,1,2.2-.8h53.3v-28a106.6,106.6,0,0,1-27.3-8.1c-9.2-4.1-20.1-9-29.2-19.9-14-16.8-14.3-36.7-14.3-42.5,0-7.2,1.1-25.7,14.3-42.5,10-12.7,22.2-18.3,29.2-21.5a89.1,89.1,0,0,1,27.3-7.5h23.4A8.616,8.616,0,0,1,323.9,72.1Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-7"
            ></path>
            <path
              id="Path_9"
              data-name="Path 9"
              d="M297.6,184.7c0-14.3.1-28.7.1-43,0-14,0-28-.1-42a42.747,42.747,0,0,0-42.1,42.7C255.5,165.4,274.4,184.4,297.6,184.7Z"
              fill="#fff"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-8"
            ></path>
            <path
              id="Path_10"
              data-name="Path 10"
              d="M57,269.3H85.2V99.3H99.3v113a109.274,109.274,0,0,0,28.2,0,95.37,95.37,0,0,0,27.9-7.4c7.3-3.2,19.2-8.5,28.9-20.6,14-17.4,14.2-37,14.2-42.5,0-8.9-1.7-26.7-14.2-42.5-9.8-12.3-21.6-17.7-28.9-21.1a91.074,91.074,0,0,0-27.9-7.8H99.2c-4.6,0-9.3-.1-14.1-.1a25.431,25.431,0,0,0-8.4,1,26.875,26.875,0,0,0-11.6,7.3,29.057,29.057,0,0,0-7.2,13.3,35.656,35.656,0,0,0-1.1,7.4Q57.1,184.35,57,269.3Z"
              fill="none"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-9"
            ></path>
            <path
              id="Path_11"
              data-name="Path 11"
              d="M127.6,184.4c0-14.3-.1-28.7-.1-43,0-14,0-28,.1-42a42.5,42.5,0,1,1,0,85Z"
              fill="#fff"
              stroke="#fff"
              stroke-width="10"
              class="svg-elem-10"
            ></path>
          </g>
        </svg> -->
      </div>

      <!-- <h1 class="mb-3">واداروم</h1> -->
      <h5 class="mb-5 animate__animated animate__zoomIn animate__delay-3s">
        برگزاری جلسات و سمینارهای آنلاین بر بستر قدرتمند <br />واحد الکترونیکی
        دانشگاه آزاد اسلامی
      </h5>
      <div class="btnSection">
        <div
          class="enter f-c-c animate__animated animate__zoomIn animate__delay-3s"
          @click="enterFunc()"
        >
          ورود
        </div>
      </div>
    </div>
    <div v-if="isShow == 2" class="context contextContent f-c-b">
      <div class="helpContent f-c-c f-d-c">
        <div class="address f-c-s w-100 mb-4">
          <span
            ><b-img
              :src="require(`@/assets/images/home/address.svg`)"
            ></b-img></span
          ><span>
            نشاني : تهران، شهرك غرب، ميدان صنعت، بلوار خوردين، خيابان مهندس
            خيابان مهستان، پلاك 19، واحد الكترونيكي دانشگاه آزاد اسلامي</span
          >
        </div>
        <div class="phone f-c-s w-100">
          <span
            ><b-img
              :src="require(`@/assets/images/home/phon.svg`)"
            ></b-img></span
          ><span> شماره تماس پشتيباني : 42863863-021</span>
        </div>
      </div>
      <b-img
        class="contentsvg"
        :src="require(`@/assets/images/home/content.svg`)"
        style="min-width: 300px; width: 25%"
      ></b-img>
    </div>
    <div v-if="isShow == 3" class="context contextHelp f-c-s f-d-c">
      <b-img
        class="contentImg"
        :src="require(`@/assets/images/home/hint.png`)"
      ></b-img>
      <div class="helpContent f-c-c">
        چه بخواهید در یک کلاس آنلاین شرکت کنید، چه وبینار بگذارید و چه جلسه
        کاری، نکته مهم این است که ارتباطی امن و مقرون به صرفه داشته باشید.
        واداروم پلتفرم مناسب این کار را برایتان فراهم کرده است. واداروم به عنوان
        یک سرویس امن، با کیفیت و مقرون به صرفه برای برگزاری کلاس‌های آنلاین،
        جلسات آنلاین و وبینار معرفی شده است و خوشبختانه با استقبال مشتریان و
        سایر صاحب نظران مواجه شده است. تیم واداروم به صورت مستمر در حال ارتقای
        نرم‌افزاری و افزایش امکانات و کیفیت این محصول است و امید داریم که
        بتوانیم به عنوان یک محصول قابل اتکا و مفید، خدماتی در شأن مشتریانمان
        ارائه کنیم. واداروم محیطی تعاملی فراهم کرده که در این محیط مدرس یا
        میزبان جلسه، می‌تواند همزمان با صحبت از طریق وبکم و میکروفون، برای
        شرکت‌کننده‌ها فایل آپلود کند تا همزمان همه آن را ببینند، و در صورت لزوم
        برای تکمیل فایل با هم به طور زنده همکاری کنند.
      </div>
    </div>
    <div v-if="isShow == 4" class="context contextHelp f-c-s f-d-c">
      <b-img
        class="contentImg"
        :src="require(`@/assets/images/home/hint.png`)"
      ></b-img>
      <div class="helpContent f-c-c">
        در صورت بروز مشکل و یا سوال می توانید با شماره 42863863-021 تماس حاصل
        نمایید.
      </div>
    </div>

    <div class="area">
      <ul class="circles">
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/1.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/2.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/3.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/4.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/5.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/6.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/7.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/8.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/9.png`)"
          ></b-img>
        </li>
        <li>
          <b-img
            class="w-100"
            :src="require(`@/assets/images/home/10.png`)"
          ></b-img>
        </li>
      </ul>
    </div>
    <b-modal
      id="homeNavbar-modal"
      centered
      button-size="sm"
      :hide-footer="footer"
      @hidden="hideModal"
      ref="homeNavbar-modal"
    >
      <template class="content f_s_s f-d-c w-100">
        <ul class="f-c-c f-d-c">
          <li
            :class="[isShow == 1 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(1)"
          >
            خانه
          </li>
          <li
            :class="[isShow == 2 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(2)"
          >
            تماس باما
          </li>
          <li
            :class="[isShow == 3 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(3)"
          >
            راهنما
          </li>
          <li
            :class="[isShow == 4 ? 'active' : '']"
            @click.prevent="selectNavbarFunc(4)"
          >
            پشتیبانی
          </li>
        </ul>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Home",
  data() {
    return {
      isShow: 1,
      footer: true,
      isshowModal: false,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
    }),
  },
  created() {},
  methods: {
    ...mapActions("gap", ["exitFunction"]),
    hideModal() {
      document.getElementById("home").classList.remove("blurBack");
      this.isshowModal = false;
    },
    mobileNavbar() {
      this.$refs["homeNavbar-modal"].show();
      this.isshowModal = true;
      document.getElementById("home").classList.add("blurBack");
    },
    selectNavbarFunc(i) {
      this.isShow = i;
      if (this.isshowModal) {
        this.$refs["homeNavbar-modal"].hide();
        document.getElementById("home").classList.remove("blurBack");
        this.isshowModal = false;
      }
      if (i == 1) {
        setTimeout(this.draw, 700);
      }
    },
    typitvs() {
      // setTimeout(() => {
      //   document.querySelector('#home h5').style.visibility = 'visible'
      // }, 3000);
      // var h1 = $(".context h3");
      // var text = $(h1).text();
      // $(h1).text("");
      // var i = 0;
      // var len = text.length;
      // setInterval(function () {
      //   if (i < len) {
      //     $(h1).append(text[i]);
      //     i++;
      //   }
      // }, 200);
    },
    enterFunc() {
      this.$router.push({ name: "login" });
    },
    draw() {
      let wrapper = document.querySelector(".wrapper svg");
      wrapper.classList.add("active");
    },
    erase() {
      let wrapper = document.querySelector(".wrapper svg");
      wrapper.classList.remove("active");
    },
  },
  mounted() {
    var newDateObj = new Date();
    if (
      Object.keys(this.user).length &&
      this.user.expire &&
      new Date(this.user.expire).getMinutes() > newDateObj.getMinutes()
    ) {
      this.$router.push({ name: "myMeets" });
    }
    setTimeout(this.draw, 700);
  },
};
</script>
<style lang="scss" scoped>
#home {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: iransans !important;
  }
  .navbar {
    position: absolute;
    top: 0;
    width: 100%;
    padding: 1rem;
    z-index: 999999;
    .navbar-collapse {
      .navbar-nav {
        img {
          width: 80px;
        }
        .nav-item {
          .nav-link {
            color: white;
            font-size: 100%;
            &:hover {
              color: #003965;
            }
          }
        }
        .active {
          .nav-link {
            color: #003965;
          }
        }
      }
    }
  }
}
* {
  margin: 0px;
  padding: 0px;
}

body {
  font-family: "Exo", sans-serif;
}

.context {
  width: 100%;
  position: absolute;
  margin: 10px auto;
  margin-top: 20vh;
  padding: 10px;
  top: 0;
  text-align: center;
  z-index: 99;
  height: -webkit-fill-available;
  overflow: auto;
  .contentImg {
    width: 80px;
    margin-bottom: 1rem;
  }
  .helpContent {
    width: 100%;
    line-height: 2.5;
    font-size: 16px;
    padding: 0 1rem;
    .address,
    .phone {
      text-align: right;
      span {
        display: inline-block;
        margin-left: 20px;
        img {
          width: 30px;
        }
      }
    }
  }
  .btnSection {
    .enter {
      cursor: pointer;
      color: white;
      font-size: 20px;
      border: 1px solid white;
      padding: 1rem 5rem;
      border-radius: 10px;
      &:hover {
        background-color: #003965;
        color: white;
      }
    }
  }
}
.contextContent {
  margin-top: 5vh;
}
.context {
  text-align: center;
  color: #fff;
}
.context h5 {
  line-height: 2.5;
}

.area {
  background: #125488;
  width: 100%;
  height: 100vh;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  animation: animate 20s linear infinite;
  bottom: -30px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 12s;
  bottom: 150px;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
  bottom: 100px;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  bottom: 200px;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 45s;
  bottom: 170px;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 35s;
  bottom: 50px;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 50px;
  height: 50px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 0.3;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
  }
}

.context h1 {
  position: relative;
  font-size: 60px;
}
.context h1:after {
  content: "";
  width: 2px;
  height: 100%;
  background: #333;
  position: absolute;
  opacity: 0;
  animation: cursor 0.5s infinite;
}
@keyframes cursor {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 850px) {
  .context {
    .helpContent {
      padding: 0.5rem;
      width: 100%;
    }
    .contentsvg {
      display: none;
    }
  }
  .contextContent {
    margin-top: 0;
  }
  .contextHelp {
    margin-top: 10vh;
  }
}
@media (max-width: 576px) {
  #home {
    .navbar .navbar-collapse {
      background-color: unset;
      border-radius: unset;
    }
    .homeNavbar {
      display: none !important;
    }
  }
  .context {
    .helpContent {
      width: 100%;
      .address,
      .phone {
        span {
        }
      }
    }
  }
}
@media (min-width: 1400px) {
  .contextContent,
  .contextHelp {
    width: 80%;
    right: 10%;
  }
}
</style>